import React from "react";
import { translate } from "../../utils/translations/translate";
import Button from "../UI/Button";
import { Popupmenu } from "../UI/PopupMenu";
import { DOWNLOAD_OPTIONS } from "../../utils/constants";
import TimesheetDetails from "./TimesheetDetails";
import { useTimesheetCorrection } from "./hooks/useTimesheetCorrection";
import { Loader } from "../Loader/Loader";
import { Alert } from "../UI/Alert";
import { TimesheetViewMode } from "./TimesheetViewMode";
import { StyledCreateTimesheetContainer } from "./styles";
export const TimesheetCorrection = ({ timesheetId }) => {
  const {
    error,
    isLoading,
    projectTasksList,
    selectedWeek,
    weekDaysArr,
    projectsList,
    toastInfo,
    syncTimesheetDetails,
    handleTimesheetSubmitActions,
    handleTimesheetModeChange,
    generateReport,
    showDraftAction,
    showSubmitButton,
    handleToastClose,
    hideServiceError,
    onDeleteAttachment,
  } = useTimesheetCorrection(timesheetId);

  return (
    <StyledCreateTimesheetContainer>
      {error && (
        <Alert type="error" message={error} onToastClose={hideServiceError} />
      )}
      {toastInfo && <Alert {...toastInfo} onToastClose={handleToastClose} />}
      <header className="tma_timesheet_header">
        <div className="tma_primary_row">
          <h1 className="page-title">
            {translate("pageTitles.timeSheetDetails")}
          </h1>
          {projectsList.length > 0 && (
            <div className="tma_submit_actions">
              {showDraftAction && (
                <Button
                  type="button"
                  className={"tma_time_draft_btn primary-outline"}
                  text={translate("labels.saveAsDraft")}
                  onClick={() => {
                    handleTimesheetSubmitActions("Draft");
                  }}
                />
              )}
              {showSubmitButton && (
                <Button
                  type="button"
                  className={"tma_time_submit_btn"}
                  variantStyle="primary"
                  text={translate("labels.submitForApproval")}
                  onClick={() => {
                    handleTimesheetSubmitActions("Submit");
                  }}
                />
              )}
              <Popupmenu
                type="button"
                popupOptions={DOWNLOAD_OPTIONS}
                variantStyle="secondary"
                label={translate("labels.moreOptions")}
                onOptionSelect={({ key }) => {
                  generateReport(key);
                }}
              />
            </div>
          )}
        </div>
      </header>
      {projectsList.map((project) => {
        if (project.mode === "read") {
          return (
            <TimesheetViewMode
              onModeChange={handleTimesheetModeChange}
              isEditable={project.isEditable}
              key={project.projectId}
              projectSavedData={project}
              taskRows={project.timesheetData}
              projectId={project.projectId}
              projectName={project.projectName}
              managerName={project.managerName}
              managerEmail={project.managerEmail}
              taskList={projectTasksList}
              selectedWeek={selectedWeek}
              weekDaysArr={weekDaysArr}
              approverComments={project.approverComments}
              status={project.status}
            />
          );
        }
        return (
          <TimesheetDetails
            syncTimesheetDetails={syncTimesheetDetails}
            onModeChange={handleTimesheetModeChange}
            key={project.projectId}
            projectSavedData={project}
            taskRows={project.timesheetData}
            showEditExit={project.showEditSwitch}
            projectId={project.projectId}
            projectName={project.projectName}
            showCopyButton={false}
            managerName={project.managerName}
            managerEmail={project.managerEmail}
            taskList={projectTasksList}
            selectedWeek={selectedWeek}
            weekDaysArr={weekDaysArr}
            approverComments={project.approverComments}
            status={project.status}
            savedAttachments={project.attachments}
            onDeleteAttachment={onDeleteAttachment}
          />
        );
      })}
      {isLoading && projectsList.length === 0 && (
        <p>{translate("labels.fetchingTimesheetInfo")}</p>
      )}
      {isLoading && <Loader />}
    </StyledCreateTimesheetContainer>
  );
};
